var $72a312d948f0214b$exports = {};
$72a312d948f0214b$exports = {
  "Clear search": "\u0391\u03C0\u03B1\u03BB\u03BF\u03B9\u03C6\u03AE \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2"
};
export { $72a312d948f0214b$exports as default };